module.exports = __webpack_public_path__ + "img/店铺排行1.92e92387.png";